import RichTextField from './RichTextField';
import Content from './Content';

RichTextField.Content = Content;

export default RichTextField;
